import React, { useState } from "react";
import processPassphrase from "../../services/passphrase/ProcessPassphrase";
import {PASSPHRASE_FROM_URL_QUERY_PARAMETERS} from "../../Constants";

const handleOnChangePassphrase = (event, passphrase, setSnpInterpretationsDict, setCategoryInfos, addPassphraseErrorMessage) => {
    event.preventDefault();
    event.stopPropagation();
    return processPassphrase(passphrase, setSnpInterpretationsDict, setCategoryInfos, addPassphraseErrorMessage);
}

const PassphraseForm = ({setSnpInterpretationsDict, setCategoryInfos}) => {
    const [passphrase, setPassphrase] = useState("");
    const [passphraseErrorMessage, setPassphraseErrorMessage] = useState("");
    const [loadInterpretationsErrorMessage, setLoadInterpretationsErrorMessage] = useState("");
    const addPassphraseErrorMessage = (message) => {
        console.log(message);
        let pastPassphraseErrorMessage = passphraseErrorMessage;
        if (pastPassphraseErrorMessage && pastPassphraseErrorMessage.length > 0) {
            pastPassphraseErrorMessage = pastPassphraseErrorMessage + "; \n";
        }
        setPassphraseErrorMessage(pastPassphraseErrorMessage + message);
    }
    const addLoadInterpretationsErrorMessage = (message) => {
        console.log(message);
        let pastLoadInterpretationsErrorMessage = loadInterpretationsErrorMessage;
        if (pastLoadInterpretationsErrorMessage && pastLoadInterpretationsErrorMessage.length > 0) {
            pastLoadInterpretationsErrorMessage = pastLoadInterpretationsErrorMessage + "; \n";
        }
        setLoadInterpretationsErrorMessage(pastLoadInterpretationsErrorMessage + message);
    }
    if (PASSPHRASE_FROM_URL_QUERY_PARAMETERS && passphraseErrorMessage.length === 0 && loadInterpretationsErrorMessage.length === 0) {
        const passphraseFromQuery = decodeURIComponent(PASSPHRASE_FROM_URL_QUERY_PARAMETERS).trim();
        // TODO DPB handle the promise returned... (prevent flash in the UI)
        processPassphrase(passphraseFromQuery, setSnpInterpretationsDict, setCategoryInfos, addPassphraseErrorMessage, addLoadInterpretationsErrorMessage);
    }
    return <div>{passphraseErrorMessage
      ? <span className={"error-message"}><br/><span
            className={"error-details"}>Details: {passphraseErrorMessage}<br/></span></span>
      : <span/>}{loadInterpretationsErrorMessage
            ? <span className={"error-message"}><br/>Not your fault -- please report this problem this app is having... <span
            className={"error-details"}>Details: {loadInterpretationsErrorMessage}</span><br/></span>
        : <span/>}
        <form onSubmit={(event) => handleOnChangePassphrase(event, passphrase, setSnpInterpretationsDict, setCategoryInfos, addPassphraseErrorMessage)}>
            <label>To access SNP interpretations, please enter the passphrase provided by your practitioner:<br/><input
                name={"passPhraseInput"}
                placeholder={"Enter passphrase here"}
                type={"text"}
                id={"passphraseInput"}
                value={passphrase}
                maxLength={255}
                minLength={20}
                size={70}
                onChange={(e) => {
                    setPassphraseErrorMessage("");
                    setPassphrase(e.target.value);
                }}
            /></label>
            <button
                type={"submit"}
                disabled={passphrase === ""}>submit</button>
            <p/>
        </form>
    </div>
}

export default PassphraseForm